<template>
    <div class="col-md-6">
        <div class="block-content">
            <form action method="post" @submit.prevent="updateProfile(user.id)">
                <div class="form-group">
                    <div class>Access ID</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="user.access_id"
                            id="username"
                        />
                    </div>
                </div>
                <div class="form-group">
                    <div class>
                        <label for="email">Email</label>
                        <input
                            type="email"
                            class="form-control"
                            v-model="user.email"
                            id="email"
                            name="material-text"
                        />
                    </div>
                </div>
               <div class="form-group">
                    <button
                        type="submit"
                        class="btn text-white btn-danger mb-10"
                    >
                        Update Profile
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { RepositoryFactory } from "../../repository/RepositoryFactory";

const UsersRepository = RepositoryFactory.get("users");
export default {
    props: {
        user: Object
    },
    data() {
        return {
            user: {},
            processing: false,
        };
    },
    created() {
        UsersRepository.loggedInUser().then(res => {
            this.user = res.data;
        });
    },
    methods: {
        updateProfile(id) {
            this.processing = true;
            let data = {
                email: this.user.email,
                access_id: this.user.access_id,
            };
            UsersRepository.updateProfile(data)
                .then(response => {
                    this.processing = false;
                    toast.fire({
                        type: "success",
                        title: "Profile updated successfully"
                    });
                })
                .catch(() => {
                    toast.fire({
                        type: "warning",
                        title: "Failed to update profile"
                    });
                });
        }
    }
};
</script>

<style scoped></style>
